'use strict';

angular.module('studies')
    .component('studyCreationAccess', {
        templateUrl: 'js/modules/studies/components/creation-access/template.html',
        controller: 'StudyCreationAccessController',
    });
